import numberFormat from '../number/numberFormat'

export default function (n, decimals) {
  let dec = decimals
  if (typeof decimals === 'undefined') {
    dec = 0
  }
  return `${numberFormat(n, dec)}원`
}
